import { render, staticRenderFns } from "./cancelled-consultations.vue?vue&type=template&id=02d1ef34&"
import script from "./cancelled-consultations.vue?vue&type=script&lang=js&"
export * from "./cancelled-consultations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports